import styled, {css} from 'styled-components'
import {H1} from 'styled';

export const HeadingStyle = styled(H1)`
  font-size: ${props => props.fontSize};
  font-weight: ${props => props.fontWeight};
  color: ${props => props.color};

  ${props =>
    props.leaderStyle &&
    css`
      background: #46344E;
      color: white;

    `};
    margin-bottom:0;
`

export const CardWrapper = styled.section`
  flex-wrap: wrap;
  margin: 0 0 1em 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (min-width: 768px) {
    flex-direction: row;
  }
  ${props =>
    props.leaderStyle &&
    css`
      background: #46344E;
      color: white;

    `};
`
export const CardStyle = styled.section`
margin-top:2em;
 img {
   border-radius: 50%;
 }
 img, section {
    display:inline-block;
  }

  @media (min-width: 768px) {
    width: 48%;
  }

  @media (min-width: 1200px) {
    width: 33%;
  }
 
`

export const NameStyle = styled.p`
font-size: 18px;
margin-bottom:0.2em;
color: #e30613;
${props =>
    props.leaderStyle &&
    css`
      color: white;
    `};
`

export const JobTitleStyle = styled.span`
font-size: 14px;
font-weight:300;
color: rgb(0,0,0);
${props =>
    props.leaderStyle &&
    css`
      color: white;
    `};

`